import type { ReactElement } from 'react';

import amSrc from 'payment-img/credit-card/american_express.png';
import amSrc2 from 'payment-img/credit-card/american_express@2x.png';
import dcSrc from 'payment-img/credit-card/diners_club.png';
import dcSrc2 from 'payment-img/credit-card/diners_club@2x.png';
import dSrc from 'payment-img/credit-card/discover.png';
import dSrc2 from 'payment-img/credit-card/discover@2x.png';
import jcbSrc from 'payment-img/credit-card/jcb.png';
import jcbSrc2 from 'payment-img/credit-card/jcb@2x.png';
import mcSrc from 'payment-img/credit-card/mastercard.png';
import mcSrc2 from 'payment-img/credit-card/mastercard@2x.png';
import defSrc from 'payment-img/credit-card/unknown.png';
import defSrc2 from 'payment-img/credit-card/unknown@2x.png';
import visaSrc from 'payment-img/credit-card/visa.png';
import visaSrc2 from 'payment-img/credit-card/visa@2x.png';

type Props = {
  brand: string,
  className?: string;
};

function cardIconSrc(brand: string): Array<string> {
  switch (brand.toLowerCase().replace(/[\s-_]*/, '')) {
    case 'visa':
      return [visaSrc, visaSrc2];

    case 'mastercard':
      return [mcSrc, mcSrc2];

    case 'american express':
      return [amSrc, amSrc2];

    case 'jcb':
      return [jcbSrc, jcbSrc2];

    case 'dinersclub':
      return [dcSrc, dcSrc2];

    case 'discover':
      return [dSrc, dSrc2];

    default:
      return [defSrc, defSrc2];
  }
}

function CardImg({ brand, className }: Props): ReactElement {
  const [src, src2] = cardIconSrc(brand);

  return (
    <img
      src={src}
      srcSet={`${src2} 2x`}
      alt={brand}
      className={className}
    />
  );
}

export default CardImg;
